let SettingsArea = () => {
  return (
    <div className="main-profile-box-left-single-flex main-profile-box-left-edit-info">
      <EditUserElement
        textElement={"Andrés Soto"}
        imageElement={"https://img.icons8.com/small/24/null/user.png"}
        functionElement={"empty for now"}
      />
      <EditUserElement
        textElement={"andressoliz@gmail.com"}
        imageElement={"https://img.icons8.com/small/24/null/secured-letter.png"}
        functionElement={"empty for now"}
      />
      <EditUserElement
        textElement={"25/12/2004"}
        imageElement={"https://img.icons8.com/small/24/null/birthday.png"}
        functionElement={"empty for now"}
      />
    </div>
  );
};

let EditUserButton = () => {
  return (
    <>
      <button className="button-app edit-button-style edit-button-to-hide">
        <img src="https://img.icons8.com/metro/12/null/pencil.png" />
      </button>
    </>
  );
};

let EditUserElement = ({ textElement, imageElement, functionElement }) => {
  return (
    <div className="editable-element">
      <img src={imageElement} className="icon-editable-element" />
      <span>{textElement} </span>
      <EditUserButton />
    </div>
  );
};

export default SettingsArea;
